var map = {
	"./message-attendance.png": 5040,
	"./message-clearplate.png": 40660,
	"./message-dorm.png": 21425,
	"./message-educational.png": 39340,
	"./message-elective.png": 29368,
	"./message-leave.png": 63608,
	"./message-moral.png": 31592,
	"./message-recipes.png": 79544
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44656;